/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.CrossReferences";
        /**
         * Right now this look pretty awful, even taking into account the lack of translated strings.
         * Ideally:
         * - Hide the column header completely, we *know* it's the document name
         * - Maximise the width of the table, there's a whole lot of pointless padding
         */
        class CrossReferencesWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("CrossReferencesWidgetTypeClass.createInstance()");
                    return new CrossReferencesWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("CrossReferencesWidgetTypeClass._storeHtml()");
                    CrossReferencesWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("CrossReferencesWidgetTypeClass::constructor");
                if (CrossReferencesWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/CrossReferences/cross-references.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.CrossReferencesWidgetTypeClass = CrossReferencesWidgetTypeClass;
        class CrossReferencesWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._instanceReady = false;
                this._displayPending = false;
                this._stealthHideButton = null;
                this._collapseState = "Show";
                this._outerDiv = null;
                this._refreshTriggers = null;
                this._parentDocId = null;
                this._filterText = null;
                this._showFilterIcon = null;
                this._hideFilterIcon = null;
                this._filter = null;
                this._activateIntoSlots = [WPTNamespace.Utilities.RELATED_SLOT_KEY];
                this._reactToSlots = [WPTNamespace.Utilities.PRIMARY_SLOT_KEY];
                this._lastReactedSlots = [];
                this._xrefComponentContainer = null;
                this._xrefComponent = null;
                this.presentInstance = () => {
                    this._log.info("CrossReferencesWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = CrossReferencesWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._outerDiv = this._container.querySelector('div.widget');
                    this._xrefComponentContainer = this._container.querySelector('#crossReferencesHolder');
                    this._stealthHideButton = this._container.querySelector('#xrefStealthButton');
                    this._filterText = this._container.querySelector('#crossReferencesFilter');
                    this._showFilterIcon = this._container.querySelector('#crossReferencesShowFilter');
                    this._hideFilterIcon = this._container.querySelector('#crossReferencesCancelFilter');
                    this._filter = this._container.querySelector('.widget__filter');
                    this._widgets.setTitle(this._config, this._container.querySelector('#crossReferencesWidgetTitle'), 'STR_WPT_CROSS_REFERENCES');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'placeholder', 'STR_WPT_FILTERLIST');
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'aria-label', 'STR_WPT_FILTERLIST');
                    this._core.Helper.setElementTranslationAttribute(this._showFilterIcon, 'title', 'STR_WPT_FILTER');
                    this._core.Helper.setElementTranslationAttribute(this._hideFilterIcon, 'title', 'STR_WPT_HIDE_FILTER');
                    this._core.Helper.setElementTranslationAttribute(this._stealthHideButton, 'title', 'STR_WPT_HIDE');
                    this._stealthHideButton.addEventListener('click', this._stealthHide);
                    this._filterText.addEventListener('keyup', this._doFilter);
                    this._showFilterIcon.addEventListener('click', this._showFilter);
                    this._hideFilterIcon.addEventListener('click', this._hideFilter);
                    this._container.querySelector('.crossReferencesClearFilter').addEventListener('click', this._clearFilter);
                    // Set up component
                    /*
                    if(config.hasOwnProperty('DisplayOptions') && (config.DisplayOptions != null)) {
                        this._noteComponentConfig = config.DisplayOptions;
                    }
                    */
                    let config = this._config;
                    if (config.hasOwnProperty('CollapseState') && (config.CollapseState != null)) {
                        this._collapseState = config.CollapseState;
                    }
                    if (config.hasOwnProperty('ActivateIntoSlots') && (config.ActivateIntoSlots != null) && (config.ActivateIntoSlots.length > 0))
                        this._activateIntoSlots = config.ActivateIntoSlots;
                    if (config.hasOwnProperty("ReactToSlots") && (config.ReactToSlots != null))
                        this._reactToSlots = config.ReactToSlots;
                    if (config.hasOwnProperty('RefreshTriggers') && config.RefreshTriggers && (config.RefreshTriggers.length > 0))
                        this._refreshTriggers = config.RefreshTriggers;
                    else
                        this._refreshTriggers = [];
                    this._core.Functions.addDefaultsToTriggerEvents(this._refreshTriggers);
                    this._xrefComponent = new Widgets.ComponentCrossReferences(this._core, this._xrefComponentContainer, this);
                    this._xrefComponent.ErrorCallback = this._callErrorHandler;
                    this._xrefComponent.FailCallback = this._callFailedHandler;
                    this._xrefComponent.present();
                    this._xrefComponent.DocSelectedCallBack = this._docSelected;
                    this._type.instanceReady(this.getHandle());
                    this._instanceReady = true;
                };
                this._callFailedHandler = (json) => {
                    this._log.info("CrossReferencesWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("CrossReferencesWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                };
                this._stealthHide = (event) => {
                    this._log.info("CrossReferencesWidgetInstanceClass._stealthHide()");
                    this._core.Functions.hideElement(this._outerDiv);
                };
                this._docSelected = (doc) => {
                    this._log.info("CrossReferencesWidgetInstanceClass._docSelected()");
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                    navEvent.ActivationID = doc.ItemNum;
                    navEvent.PrimaryContext = doc;
                    navEvent.Layout = this._currentLayout;
                    navEvent.Slots = this._activateIntoSlots;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this.showRefsForDocument = (doc) => {
                    this._log.info("CrossReferencesWidgetInstanceClass.showRefsForDocument()");
                    this._clearErrors();
                    this._parentDocId = doc.ItemNum;
                    this._xrefComponent.showRefsForDocument(doc);
                };
                this.showRefsForDocumentId = (doc) => {
                    this._log.info("CrossReferencesWidgetInstanceClass.showRefsForDocumentId()");
                    this._clearErrors();
                    this._parentDocId = doc;
                    this._xrefComponent.showRefsForDocumentId(doc);
                };
                this.clearDisplay = () => {
                    this._log.info("CrossReferencesWidgetInstanceClass.clearDisplay()");
                    this._clearErrors();
                    this._parentDocId = null;
                    this._xrefComponent.clearDisplay();
                };
                this._showFilter = () => {
                    this._log.info("CrossReferencesWidgetInstanceClass._showFilter()");
                    this._core.Functions.hideElement(this._showFilterIcon);
                    this._core.Functions.showElement(this._hideFilterIcon);
                    this._core.Functions.showElement(this._filter);
                    this._filterText.focus();
                };
                this._hideFilter = () => {
                    this._log.info("CrossReferencesWidgetInstanceClass._hideFilter()");
                    this._core.Functions.hideElement(this._hideFilterIcon);
                    this._core.Functions.showElement(this._showFilterIcon);
                    this._core.Functions.hideElement(this._filter);
                    this._clearFilter();
                };
                this._clearFilter = () => {
                    this._log.info("CrossReferencesWidgetInstanceClass._clearFilter()");
                    this._core.Functions.clearAndFocusInputElement(this._filterText);
                    this._doFilter();
                };
                this._doFilter = () => {
                    this._log.info("CrossReferencesWidgetInstanceClass._doFilter()");
                    let filterText = this._filterText.value;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("filtering with: " + filterText);
                    }
                    this._xrefComponent.filterReferences(filterText);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("CrossReferencesWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
            activate(context) {
                this._log.info("CrossReferencesWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                        let slots = this._reactToSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (slots.length > 0) {
                            if ((this._collapseState == "Stealth") && this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS) && context.Decloak)
                                this._core.Functions.showElement(this._outerDiv);
                            if (!this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                                this.showRefsForDocumentId(context.ActivationID);
                                // only remember slots we react to
                                this._lastReactedSlots = slots;
                            }
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED:
                        let intersection = this._lastReactedSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (intersection.length > 0) {
                            this._lastReactedSlots = [];
                            this.clearDisplay();
                            if (this._collapseState == "Stealth")
                                this._core.Functions.hideElement(this._outerDiv);
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.REQUEST_TO_ADVERTISE:
                        let capabilityEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.RESPONSE_CAPABILITY_PUBLISHED);
                        capabilityEvent.ActivationID = 0;
                        capabilityEvent.PrimaryContext = ["CrossReferences"];
                        capabilityEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(capabilityEvent);
                        break;
                    default:
                        if (this._refreshTriggers.length > 0) {
                            // Loop with iterator so we can escape when necessary
                            for (let i = 0; i < this._refreshTriggers.length; i++) {
                                let trigger = this._refreshTriggers[i];
                                if (this._core.Functions.triggerEventMatches(trigger, context)) {
                                    if (this._parentDocId)
                                        this.showRefsForDocumentId(this._parentDocId);
                                    // Only trigger once
                                    return;
                                }
                                else {
                                    continue;
                                }
                            }
                        }
                        break;
                }
            }
        }
        CrossReferencesWidgetInstanceClass.HtmlData = null;
        Widgets.CrossReferencesWidgetInstanceClass = CrossReferencesWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
